module.exports = __webpack_public_path__ + "static/media/Semiconductors_Thumb_1.56352bcc.jpg";